import { useParams } from "react-router-dom";

const useBID = () => {
  const params = useParams();
  const bId = params.bId;
  if (bId === undefined)
    throw new Error("useBIDは:bIdを含むPath配下でしか使えません");
  return bId;
};
export default useBID;
